import React, { useState } from "react";
import { getUsers, validatePin, updatePassword } from "../utils/auth";

export default function ResetPassword() {
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleUsernameSubmit = (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const user = getUsers().find(u => u.username === username);
    if (!user) {
      setError("Användaren finns inte.");
      return;
    }
    if (user.locked) {
      setError("Kontot är låst. Kontakta admin.");
      return;
    }
    setStep(2);
  };

  const handlePinSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const valid = await validatePin(username, pin);
    if (!valid) {
      setError("Felaktig pinkod. Efter 3 försök låses kontot.");
      return;
    }
    setStep(3);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const user = getUsers().find(u => u.username === username);
    if (!user) {
      setError("Ett fel uppstod. Försök igen.");
      return;
    }
    try {
      await updatePassword(user.id, newPassword);
      setMessage("Lösenordet är återställt! Du kan nu logga in.");
      setStep(1);
      setUsername("");
      setPin("");
      setNewPassword("");
    } catch {
      setError("Kunde inte uppdatera lösenordet.");
    }
  };

  return (
    <div className="app-wrapper">
      <h2>Återställ lösenord</h2>

      {step === 1 && (
        <form onSubmit={handleUsernameSubmit}>
          <label>Användarnamn</label>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <button type="submit">Nästa</button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handlePinSubmit}>
          <label>Pinkod (4 siffror)</label>
          <input
            type="password"
            value={pin}
            onChange={e => setPin(e.target.value)}
            pattern="\d{4}"
            required
          />
          <button type="submit">Verifiera pinkod</button>
        </form>
      )}

      {step === 3 && (
        <form onSubmit={handlePasswordSubmit}>
          <label>Nytt lösenord</label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
          />
          <button type="submit">Spara nytt lösenord</button>
        </form>
      )}

      {message && <div style={{ color: "green", marginTop: "1rem" }}>{message}</div>}
      {error && <div style={{ color: "red", marginTop: "1rem" }}>{error}</div>}
    </div>
  );
}
